import { IMapper, TimeZoneProvider, useMapper } from '@fareye/common'
import { IPageRenderConfig } from '@fareye/types'
import { RenderControl } from '@fareye/ui'
import React from 'react'
import { MultiModelListing } from '..'
import version from '../../../config/npmVersions'
//NOTE: This config is used to render this Route Listing we will move this to server.

export function MultiModalListingMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData}>
        <MultiModelListing
          {...props}
          config={apiData.data as IPageRenderConfig}
        />
      </RenderControl>
    </TimeZoneProvider>
  )
}
